import OpSearchTree from "./index.vue";
var opsearchtree = {
  install: function install(Vue) {
    Vue.component("OpSearchTree", OpSearchTree);
  }
};
export default opsearchtree;